import { registerLocaleData } from '@angular/common';
import { DatePipe } from '@angular/common';
import { HttpClientModule, HttpClientXsrfModule, provideHttpClient } from '@angular/common/http';
import localeDECH from '@angular/common/locales/de-CH';
import { isDevMode, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { PmtPushNotificationsConfiguration } from '@premotec/pmt-push-notifications';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainModule } from './main/main.module';
import { SecurityModule } from './security/security.module';
import { SharedServiceWorkerService } from './shared/services/shared-service-worker.service';
import { VersionUpdateService } from './shared/services/version-update.service';
import { SharedModule } from './shared/shared.module';
import { TranslocoRootModule } from './transloco/transloco-root.module';

registerLocaleData(localeDECH);

const defaultModules = [
    BrowserModule,
    BrowserAnimationsModule
];

const internalModules = [
    AppRoutingModule,
    SharedModule,
    MainModule,
    SecurityModule
];

const externalModules = [TranslocoRootModule];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        defaultModules,
        internalModules,
        externalModules,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN'
        })
    ],
    providers: [
        DatePipe,
        VersionUpdateService,
        { provide: LOCALE_ID, useValue: 'de-CH' },
        // Scope cannot be null if defined => otherwise the translation will not work
        { provide: TRANSLOCO_SCOPE, useValue: ['pmtBootstrap', 'pmtDatepicker', 'pmtPushNotifications'] },
        {
            provide: PmtPushNotificationsConfiguration,
            useValue: {
                api: environment.api,
                vapidPublicKey: environment.pushNotifications.vapidPublicKey
            }
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(
        // Ensure it is constructed
        private sharedServiceWorkerService: SharedServiceWorkerService,
    ) { }
}
function withXsrfProtection(arg0: { cookieName: string; headerName: string; }): import("@angular/common/http").HttpFeature<import("@angular/common/http").HttpFeatureKind> {
    throw new Error('Function not implemented.');
}

